const { createTheme } = require("@mui/material/styles");
const breakpoints = {
		values: {
			xs: 0,
			sm: 960,
			md: 1200,
			lg: 1350,
			xl: 1420,
		},
	};
const defaultTheme = createTheme({
  breakpoints,
});


const fontFamily = [
			"Open Sans",
			"-apple-system",
			"BlinkMacSystemFont",
			'"Segoe UI"',
			'"Helvetica Neue"',
			"Arial",
			"sans-serif",
			'"Apple Color Emoji"',
			'"Segoe UI Emoji"',
			'"Segoe UI Symbol"',
		].join(",");

const themeConfig = {
	palette: {
		body: {
			main: "#ffffff",
			light: "#ffffff",
			dark: "#e0e0e0",
			contrastText: "#212121",
		},
    figcaption: {
      main: "#212121"
    },
    dark: {
      main: "#212121",
      contrastText: "#ffffff",
    },
    light: {
			light: "#ffffff",
			main: "#f5f5f5",
			dark: "#e0e0e0",
			contrastText: "#212121",
		},
    subnav: {
      light: "#E8E8E8",
      main: "#fafafa",
      contrastText: "#757575"
    },
		appBar: {
			public: {
				main: "#2c0065",
				light: "#2c0065",
				dark: "#2c0065",
				contrastText: "#ffffff",
				gradient: "linear-gradient(90deg, #2c0065, #622c6d)",
			},
		},
		primary: {
			main: "#2c0065",
			light: "#2c0065",
			dark: "#2c0065",
			contrastText: "#ffffff",
		},
		secondary: {
			main: "#1c60ce",
			light: "#499ade",
			dark: "#144ca6",
			contrastText: "#ffffff",
		},
    divider: "#E0E0E0",
		underline: {
			main: "#f6b600",
		},
		footer: {
			main: "#2c0065",
			light: "#3c7ee8",
			dark: "#2c0065",
			gradient: "linear-gradient(90deg, #2c0065, #622c6d)",
      contrastText: "#ffffff",
		},
    colophon: {
			main: "#2c0065",
			light: "#3c7ee8",
			dark: "#2c0065",
			gradient: "linear-gradient(90deg, #2c0065, #622c6d)",
      contrastText: "#ffffff",
		},
		link: {
			main: "#212121",
			light: "#383838",
			dark: "#212121",
		},
    buttonLink: {
			main: "#1c60ce",
			light: "#4083ed",
			dark: "#114dad",
		},
		titleBar: {
			public: {
				main: "transparent",
				light: "transparent",
				dark: "transparent",
				contrastText: "#212121",
			},
		},
	},
	typography: {
		fontSize: 16,
		fontFamily,
    fontWeightBold: 700,
		subtitle2: {
			fontFamily,
			fontWeight: 700,
			opacity: 1,
			color: "#212121",
		},
		body1: {
			fontSize: "0.98rem",
		},
		body2: {
			opacity: 1,
		},
		h1: {
			fontFamily,
			fontWeight: 700,
			fontSize: "2rem",
      letterSpacing: "-0.01562em",
		},
		h2: {
			fontWeight: 700,
			fontSize: "18px",
			marginTop: "32px",
      fontFamily,
		},
		h3: {
			fontWeight: 700,
			fontSize: "22px",
			marginTop: "16px",
      fontFamily,
      letterSpacing: "-0.01562em",
		},
		h4: {
      fontWeight: 700,
			fontSize: "1.35rem",
			marginTop: "16px",
      fontFamily,
      letterSpacing: "-0.01562em",
      [defaultTheme.breakpoints.down("md")]: {
        fontSize: "1.35rem",
      },
		},
		h5: {
			fontWeight: 700,
			fontSize: "1rem",
			marginTop: "16px",
      fontFamily,
		},
		h6: {
			fontWeight: 700,
			fontSize: "14px",
			marginTop: "0",
      fontFamily,
		},
		titleBar: {
			fontFamily,
		},
    brandTitle: {
			fontFamily,
      fontSize: "22px",
      lineHeight: 1.2,
      fontWeight: 700,
      [defaultTheme.breakpoints.down("sm")]: {
        fontSize: "16px",
      }
		},
    brandSubtitle: {
			fontFamily,
      fontSize: "14px",
      lineHeight: 1.2,
      fontWeight: 400,
      marginTop: "4px",
      fontStyle: "normal",
      [defaultTheme.breakpoints.down("sm")]: {
        fontSize: "11px",
      }
		},
    nav: {
			fontFamily,
      textTransform: "uppercase",
      fontSize: "14px",
      fontWeight: 700,
		},
    subnav: {
			fontFamily,
      textTransform: "none",
      fontSize: "16px",
      fontWeight: 700,
		},
		subtitle1: {
			fontStyle: "normal",
			fontWeight: 700,
			lineHeight: 1.5,
			letterSpacing: "-0.01562em",
			fontSize: "1.6rem",
		},
		overline: {
			fontSize: "0.8rem",
			lineHeight: 1.4,
			textTransform: "uppercase",
      letterSpacing: "0em",
      marginBottom: "0",
		},
	},
	components: {
		MuiPaper: {
			styleOverrides: {
				root: {
					borderRadius: "0px",
				},
			},
		},
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: "none",
        }
      }
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          paddingTop: "35px",
          paddingBottom: "35px",
        }
      }
    },
		MuiButton: {
			styleOverrides: {
				root: {
					variants: [
						{
							props: { size: "small", variant: "text" },
							style: {
                lineHeight: 1.3,
								fontSize: "0.96rem",
								textTransform: "uppercase",
							},
						},
            {
							props: { variant: "contained" },
							style: {
								fontSize: "0.8rem",
								textTransform: "none",
                fontWeight: 600,
                textAlign: "left",
                borderRadius: 3,
							},
						},
            {
							props: { variant: "contained", color: "primary" },
							style: {
								fontSize: "16px",
								textTransform: "uppercase",
                fontWeight: 600,
							},
						},
					],
				},
			},
		},
		MuiInputBase: {},
	},
  breakpoints,
  containerMaxWidths: {
		xs: "100%",
		sm: "880px",
		md: "1048px",
		lg: "1048px",
		xl: "1048px",
  },
	cloverleaf: {
		css: `
      html:not(.is-home) #___gatsby {
        background-color: #f5f5f5;
      }
      html:not(.is-home) #___gatsby .title-bar > .MuiContainer-root {
        padding-top: 0;
        padding-bottom: 0;
      }
      html:not(.is-home) #___gatsby .main-container .main-wrapper,
      html:not(.is-home) #___gatsby .title-bar header {
        background-color: #ffffff;
        padding: 20px 30px 30px;
      }
      html:not(.is-home) #___gatsby .title-bar header {
        padding-top: 40px;
        padding-bottom: 20px;
      }
      html:not(.is-home) #___gatsby .main-container {
        padding-top: 0;
        padding-bottom: 0;
      }
      #___gatsby .excerpt-card .excerpt-content .excerpt-summary {
        font-style: italic;
      }
      #___gatsby .closing-section > *:last-child {
        display: none;
      }
      #___gatsby .title-blog .titles-box > * {
        margin-top: 0 !important; 
      }
      #___gatsby .title-blog .titles-box time {
        text-transform: none;
        font-size: 1rem;
      }
      @media screen and (min-width: 1200px){
        html.is-home #___gatsby .main-grid-right aside {
          position: relative;
        }
        html.is-home #___gatsby .main-grid-right aside:before {
          content: " ";
          width: 1px;
          height: 100%;
          background-color: #dfdfdf;
          position: absolute;
          top: 0;
          left: -40px;
        }
      }
      @media screen and (max-width: 1199px){
        html.is-home #___gatsby .closing-section > *:last-child {
          display: block;
          padding-left: 30px;
          padding-right: 30px;
          padding-bottom: 30px;
        }
        html.is-home #___gatsby #sidebar > *:first-child {
          display: none;
        }
        
      }
      #mc_embed_signup .mc-field-group {
        clear: left;
        position: relative;
        width: 96%;
        padding-bottom: 3%;
        min-height: 50px;
        display: grid;
      }
      #mc_embed_signup .mc-field-group label {
        display: block;
        margin-bottom: 3px;
      }

      #mc_embed_signup .mc-field-group input {
        display: block;
        width: 100%;
        padding: 8px 0;
        text-indent: 2%;
      }

      #mc_embed_signup .indicates-required {
        text-align: right;
        font-size: 11px;
        margin-right: 4%;
      }

      #mc_embed_signup .asterisk {
        color: #e85c41;
        font-size: 150%;
        font-weight: normal;
        position: relative;
        top: 5px;
      }

      #mc_embed_signup .button {
        clear: both;
        background-color: #111;
        border: 0 none;
        border-radius: 4px;
        transition: all 0.23s ease-in-out 0s;
        color: #ffffff;
        cursor: pointer;
        display: inline-block;
        font-size: 15px;
        font-weight: normal;
        height: 32px;
        line-height: 32px;
        margin: 0 5px 10px 0;
        padding: 0 22px;
        text-align: center;
        text-decoration: none;
        vertical-align: top;
        white-space: nowrap;
        width: fit-content;
        width: -moz-fit-content;
      }

      #mc_embed_signup .button:hover {
        background-color: #222;
      }

		`,
		googleFont: "Open+Sans:ital,wght@0,400;0,700;1,400;1,700",
		labels: {
			filtersTitle: "Filters",
			typeTitle: "Content Type",
		},
    navbar: {
      layout: "compact",
      align: "left",
      padding: 3.4,
borderRadius: 3
    },
		newsletter: {
			action:
				"https://newsroom.us9.list-manage.com/subscribe/post?u=feac0b795a4b6268dd6b730d8&amp;id=cf5ce4f444",
			title: "Sign up for our weekly newsletter",
			buttonColor: "secondary",
			titleVariant: "h6",
		},
		brand: {
			print: "/logo-private.png",
			paddingTop: 0.001,
			paddingBottom: 0.0001,
		},
    image: {
      aspectRatio: {
        landscape: "3 / 2.02",
      }
    },
		single: {
			introLabel: "Media Contact:",
			style: "flush",
			reverseDate: true,
      padding: 1.5,
      spacing: 4,
		},
    highlight: {
        horizontal_space: 3,
        vertical_space: 3,
        bg_color_luminosity: "main"
    },
		share: {
			customSummaryField: "field_subtitle",
			position: "side",
		},
		tags: {
			position: "bottom",
		},
		sidebar: {
			style: "flush",
		},
		list: {
			style: "flush",
      hideSummaryOnMobile: true,
		},
    text: {
      inlineImageFullWidth: true,
    },
		components: {
			More: {
				link: true,
				color: "buttonLink",
				size: "small",
			},
		},
	},
};
module.exports = themeConfig;
